import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import SelectAutocomplete from '../../../../widgets/SelectAutocomplete';
import { allEquiposAction } from '../EquiposAction';

const SelectFieldEquiposComponent = ({
  onChange,
  value = '',
  data,
  selects = [],
  isAutoComplete,
}) => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const equiposStore = Redux.useSelector((state) => state.equipos);

  const [equipos, setEquipos] = React.useState([]);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      equiposStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setEquipos(items);
    } else {
      if (data) {
        setEquipos(data);
      } else {
        setEquipos(equiposStore.all);
      }
    }
  };

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && equiposStore.all && equiposStore.all.length === 0) {
        await allEquiposAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => _handlerSelects(), [selects]);

  const select = (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${CONST.equipos.name}`}>
        {CONST.equipos.label}
      </InputLabel>
      <Select
        id={CONST.equipos.name}
        value={value?.toString()}
        labelId={`label_${CONST.equipos.name}`}
        label={CONST.equipos.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {equipos.map((el, index) => {
          return (
            <MenuItem key={`equipos-${index}`} value={el.id}>
              {el.nombre}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );

  const autoComplete = (
    <SelectAutocomplete
      id="combo-box-demo-equipos"
      opt={equipos}
      type={CONST.equipos.name}
      onChange={(_, newValue) => onChange(newValue?.id)}
      l="Equipos"
    />
  );

  return isAutoComplete ? autoComplete : select;
};

export default SelectFieldEquiposComponent;
